import { useEffect, useMemo, useState } from 'react';
import { useFilters } from './useFilters';



export const useCardRoutes = () => {
  const {applyFilters} = useFilters();
  const [filtersSaver, setFiltersSaver] = useState<any | null>(null);
  const [cardsHistory, setCardsHistory] = useState<any[]>([]);
  const [freezeCardHistory, setFreezeCardsHistory] = useState(false);
  const {currentFilters} = useFilters();

  const allFiltersClearedObj = {
    pageNo: null,
    perPage: null,
    addTeam: null,
    compare: null,
    compareSort: null,
    activeSection: null,
    surveyReport: null,
    prm: null,
    riskAnalysis: null,
    predictiveStates: null,
    performers: null,
    categories: null,
    card: null,
  };

  const isBackButtonVisible = useMemo(() => {
    return cardsHistory.length > 0;
  }, [cardsHistory]);

  const goBackToCard = () => {
    setFreezeCardsHistory(true);
    const cardsHistoryCopy = [...cardsHistory];
    const lastCardFilters = cardsHistoryCopy.pop();
    setCardsHistory(cardsHistoryCopy);
    applyFilters(lastCardFilters);
  };

  useEffect(() => {
    if(freezeCardHistory){
      if(cardsHistory.length === 0){
        setFiltersSaver(undefined);
      }
      return setFreezeCardsHistory(false);
    }
    if(filtersSaver?.card !== currentFilters?.card && !freezeCardHistory) {
      const lastCardFilters = {...allFiltersClearedObj,...filtersSaver };
      const cardsArrNewState = [...cardsHistory, lastCardFilters];
      setCardsHistory(cardsArrNewState);
    }
    setFiltersSaver(currentFilters);
  }, [currentFilters, filtersSaver]);

  return {
    allFiltersClearedObj,
    isBackButtonVisible,
    goBackToCard,
  };
};
